const studentSessionKey = 'francisneyliberato-estudante:student-session';

export function setStudentSession(session?: string) {
  if (session) localStorage.setItem(studentSessionKey, session);
  else localStorage.removeItem(studentSessionKey);
}

export function getStudentSession() {
  return localStorage.getItem(studentSessionKey) || '';
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    ...options,
    headers: {
      'content-type': 'application/json',
      ...(getStudentSession() ? { 'x-student-session': getStudentSession() } : {}),
      ...(options.headers || {})
    }
  });
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : await response.text();
  if (!response.ok) {
    const errorPayload = payload as { error?: string };
    throw new Error(typeof payload === 'object' && errorPayload.error ? errorPayload.error : 'Falha na requisição.');
  }
  return payload as T;
}

export const postJson = <T>(path: string, body: unknown) =>
  api<T>(path, { method: 'POST', body: JSON.stringify(body) });

export const deleteJson = <T>(path: string) =>
  api<T>(path, { method: 'DELETE' });
